import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema6 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema6_Aspectos_Avanzados.pdf`;
  /*const pdfUrl = "/pdf/Tema6_Aspectos_Avanzados.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 6: Aspectos Avanzados</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema6;
